<template>
  <div class="upload-file-page">
    <h2>上传文件</h2>
    <input type="file" @change="handleFileChange" />
    <el-button type="primary" :disabled="!selectedFile" @click="uploadFile">上传</el-button>
    <div v-if="uploading">正在上传...</div>
    <div v-if="uploadSuccess" class="success">上传成功！</div>
    <div v-if="uploadError" class="error">上传失败：{{ uploadError }}</div>
    <img :src="imageUrl" v-if="imageUrl" />
  </div>
</template>

<script>
import { uploadFileToAgentServer } from "@/api";
export default {
  name: "UploadFilePage",
  data() {
    return {
      selectedFile: null,
      uploading: false,
      uploadSuccess: false,
      uploadError: "",
      imageUrl: "",
    };
  },
  methods: {
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
      this.uploadSuccess = false;
      this.uploadError = "";
    },
    async uploadFile() {
      if (!this.selectedFile) return;
      this.uploading = true;
      this.uploadSuccess = false;
      this.uploadError = "";
      try {
        const response = await uploadFileToAgentServer(this.selectedFile);
        this.imageUrl = response.url; // 假设返回的响应中包含图片URL
        this.uploadSuccess = true;
      } catch (err) {
        this.uploadError = err.message;
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>

<style scoped>
.upload-file-page {
  max-width: 400px;
  margin: 40px auto;
  padding: 24px;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fafbfc;
}
button {
  margin-top: 12px;
}
.success {
  color: green;
  margin-top: 10px;
}
.error {
  color: red;
  margin-top: 10px;
}
</style>
